import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../contexts/AppContext';

const StickyCartButton = () => {
  const { totalCount, totalAmount } = useContext(AppContext);
  return (
    <div className="sticky-cart d-flex align-items-center justify-content-between p-3 shadow-lg bg-white rounded-pill">
      <div>
        <div className="small text-muted">Cart</div>
        <div className="fw-bold">{totalCount} items • ₹{totalAmount}</div>
      </div>
      <Link to="/cart" className="btn btn-danger btn-sm">View Cart</Link>
    </div>
  );
};

export default StickyCartButton;
